import Cookies from 'universal-cookie'
let cookieSettings
const cookies = new Cookies()
// Set expiry time
var days = parseInt(process.env.REACT_APP_COOKIE_EXPIRY)
var expiry = new Date()
expiry.setDate(expiry.getDate() + days)
if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
	cookieSettings = {
		path: '/',
		expires: expiry,
		secure: true,
		domain: process.env.REACT_APP_SUB_DOMAIN_URL,
		// sameSite: "lax",
	}
} else {
	cookieSettings = {
		path: '/',
		expires: expiry,
		secure: true,
		// domain: process.env.REACT_APP_SUB_DOMAIN_URL,
		// sameSite: "lax",
	}
}

var _service
function _getService() {
	if (!_service) {
		_service = this
		return _service
	}
	return _service
}
/**
 *
 * COOKIE STORAGE SERVICE
 */

function _removeCatalogURL() {
	sessionStorage.removeItem('catalog_url')
	if (cookies.get('catalog_url') !== undefined) {
		return cookies.remove('catalog_url', cookieSettings)
	}
}
function _saveToCookieStorage(key, value) {
	cookies.set(key, value, cookieSettings)
}

function _updateInCookieStorage(key, value) {
	cookies.set(key, value, cookieSettings)
}

function _getFromCookieStorage(token) {
	return cookies.get(token)
}

function _deleteFromCookieStorage(key) {
	cookies.remove(key, cookieSettings)
}

/**
 *
 * LOCAL STORAGE SERVICE
 */
function _saveToSessionStorage(key, value) {
	sessionStorage.setItem(key, value)
}

function _getFromSessionStorage(key) {
	return sessionStorage.getItem(key)
}

function _updateInSessionStorage(key, value) {
	sessionStorage.setItem(key, value)
}

function _deleteFromSessionStorage(key) {
	sessionStorage.removeItem(key)
}
function _clearSessionStorage() {
	var locale = sessionStorage.getItem('locale')
	sessionStorage.clear()
	sessionStorage.setItem('locale', locale)
}
/**
 *
 * LOCAL STORAGE SERVICE
 */
function _saveToLocalStorage(key, value) {
	localStorage.setItem(key, value)
}

function _getFromLocalStorage(key) {
	return localStorage.getItem(key)
}

function _updateInLocalStorage(key, value) {
	localStorage.setItem(key, value)
}

function _deleteFromLocalStorage(key) {
	localStorage.removeItem(key)
}
function _clearLocalStorage() {
	localStorage.clear()
}

function _nextScreen() {
	const screen = parseInt(LocalStorageService._getFromLocalStorage('screen'))
	LocalStorageService._updateInLocalStorage('screen', screen + 1)
}

function _PreviousScreen() {
	const screen = parseInt(LocalStorageService._getFromLocalStorage('screen'))
	LocalStorageService._updateInLocalStorage('screen', screen - 1)
	return true
}

function _isFirstScreen() {
	const screen = parseInt(LocalStorageService._getFromLocalStorage('screen'))
	var value = screen === 1 ? true : false
	return value
}

function _setFirstScreen() {
	LocalStorageService._updateInLocalStorage('screen', 1)
	return true
}

function _getTimer(timer) {
	if (isNaN(timer)) {
		return Date.now() + 0
	} else {
		return timer
	}
}

export const LocalStorageService = {
	_removeCatalogURL,

	_getService,
	_saveToCookieStorage,
	_getFromCookieStorage,
	_updateInCookieStorage,
	_deleteFromCookieStorage,
	_saveToSessionStorage,
	_getFromSessionStorage,
	_updateInSessionStorage,
	_deleteFromSessionStorage,
	_clearSessionStorage,
	_saveToLocalStorage,
	_getFromLocalStorage,
	_updateInLocalStorage,
	_deleteFromLocalStorage,
	_clearLocalStorage,
	_nextScreen,
	_PreviousScreen,
	_isFirstScreen,
	_setFirstScreen,
	_getTimer,
}
